import { useState } from "react";
import SelectableCard from "../SelectableCard/SelectableCard";
import { SelectableCardGroupRoot } from "./SelectableCardGroup.styles";
import { SelectableCardGroupProps } from "./SelectableCardGroup.types";

export default function SelectableCardGroup({ items, defaultValue, onCardChange }: SelectableCardGroupProps) {
    const [selectedCard, setSelectedCard] = useState<string | null>(defaultValue || null);

    const onCardClick = (value: string) => {
        setSelectedCard(value);
        onCardChange?.(value);
    };

    return (
        <SelectableCardGroupRoot>
            {items.map((card) => (
                <SelectableCard onClick={onCardClick} key={card.label} selected={selectedCard === card.value} {...card} />
            ))}
        </SelectableCardGroupRoot>
    );
}
